import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface PageHeaderProps {
  onBack: () => void;
}

export function PageHeader({ onBack }: PageHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4">
      <Button variant="ghost" size="icon" onClick={onBack} aria-label={t('common.back', 'Back')}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <h1 className="text-2xl font-bold">{t('newcmr.title', 'Edit Consignment')}</h1>
    </div>
  );
}
